// import { useQuery } from '@tanstack/react-query';
import { Electronics } from './Electronics';
import { Food } from './Food';
import { Lifestyle } from './Lifestyle';
import { PaymentPromoBanner } from './PaymentPromoBanner';
import { RealEstate } from './RealEstate';

export const shopByPopularCategories = [
  {
    title: 'Electronics',
    desc: 'TV, Cell phone, Laptops, household appliances',
    color: 'bg-[#F5F5F7]',
    image: '/images/ss-electronics.min.svg',
    link: '/electronics',
    width: '400px',
    height: '223.5',
  },
  {
    title: 'Food & Drink',
    desc: 'Grocery, Confectionery, Beverages',
    color: 'bg-[#F5F5F7]',
    image: '/images/smallsmall-grocery.min.svg',
    link: '/food-drink',
    width: '250px',
    height: '250px',
  },
  {
    title: 'Lifestyle & Consumer goods',
    desc: 'Beauty, Fashion, Household Essentials',
    color: 'bg-[#F5F5F7]',
    image: '/images/smallsmall-lifestyle.min.svg',
    link: '/lifestyle-consumer-goods',
  },
  {
    title: 'Housing',
    desc: 'Rent, Buy, Short-stay',
    color: 'bg-[#FFDE11]',
    image: '/images/ss-housing.min.svg',
    link: '/real-estate',
  },
];

export default function PopularCategories() {
  return (
    <section className="py-8 lg:mx-10">
      <h3 className="text-3xl text-center font-semibold mb-7 px-8 lg:px-5">
        Explore popular categories
      </h3>

      <Electronics />

      <PaymentPromoBanner />

      {/* Three column grid for Lifestyle, RealEstate, and Food */}
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-2 px-4 lg:px-0">
        <Lifestyle />
        <RealEstate />
        <Food />
      </div>
    </section>
  );
}
